export default __webpack_public_path__ + "f596dff63119e79a86b909a51d77d64c.svg";